/*
 * Where the login has to lead back to.
 *
 * The path alone is not the place. Every master-detail area keeps its
 * selection in the query string — `?partner=P-11204`, `?debitor=…`,
 * `?tab=…` — precisely so that a record can be linked to; a link that
 * survives the login as its bare path lands on the list the reader was
 * trying to skip past. Whatever a bookmark holds has to travel with
 * it, query and fragment included.
 *
 * Works for both kinds of location this app has: the one react-router
 * hands to a component and `window.location` behind the OIDC
 * callbacks, which agree on these three fields.
 */
export function locationPath(location) {
  return `${location.pathname}${location.search ?? ''}${location.hash ?? ''}`;
}
